import 'core-js/stable'
import 'regenerator-runtime/runtime'

import '@fortawesome/fontawesome'
import '@fortawesome/fontawesome-free-solid'
import '@fortawesome/fontawesome-free-regular'
import '@fortawesome/fontawesome-free-brands'

import '@hotwired/turbo-rails'

// lazyload の実装
import lozad from 'lozad'
const observer = lozad()
observer.observe()


import { Application } from 'stimulus'
const application = Application.start()

// Vite用: import.meta.globでStimulusコントローラを自動登録
const modules = import.meta.glob('./stimulus_controllers/**/*.js', { eager: true })
Object.entries(modules).forEach(([path, mod]) => {
  if (mod.default) {
    // ファイル名からコントローラ名を抽出 (例: './stimulus_controllers/toggle_controller.js' -> 'toggle')
    const name = path.match(/\.\/stimulus_controllers\/(.+)_controller\.js$/)?.[1]
    if (name) {
      application.register(name, mod.default)
    }
  }
})

// NodeList.forEach for IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the vite_image_tag helper in views (e.g <%= vite_image_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
